import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";
import { faRefresh } from "@insidebeehive/fortawesome/pro-regular-svg-icons/faRefresh";

import { Button } from "../ui/button";
import { Icon } from "../ui/icon";
import { Body, Page } from "../custom/page";
import { Flex } from "../ui/flex";

import disconnect from "~/assets/error/disconnect.png";

const ErrorComponent = () => {
  const error: any = useRouteError();
  console.error(error);
  const isRouteError = isRouteErrorResponse(error);
  const navigate = useNavigate();

  const navigateToHome = () => {
    navigate("/login");
  };
  const reload = () => {
    navigate(0);
  };
  let errorData = {
    error: "Unknown Error",
    status: 500,
    statusText: "Internal server error occurred!",
  };
  if (isRouteError) {
    errorData = {
      error: error?.data,
      status: error?.status || 500,
      statusText: error?.statusText || "Internal server error occurred!",
    };
  } else {
    errorData.error = error?.message;
  }

  return (
    <Page>
      <Body>
        <Flex justifyContent="center" alignItems="center" className="h-[calc(100vh-2rem)] md:h-screen pb-10 md:pb-0 overflow-auto md:overflow-clip">
          <div className="lg:px-24 lg:py-24 md:py-20 md:px-44 items-center flex justify-center flex-col-reverse lg:flex-row md:gap-28">
            <div className="xl:pt-0 w-full h-full xl:w-2/3 relative pb-12 lg:pb-0">
              <div className="relative">
                <div className="absolute">
                  <div className="w-full px-4 md:px-0">
                    <h1 className="mt-2 text-gray-800 font-extrabold text-2xl">{errorData?.statusText}</h1>
                    <p className="font-bold text-error">{errorData?.error}</p>
                    <p className="mt-6 mb-4 text-secondary-foreground font-extralight space-x-2">
                      Sorry about that! Please try reloading or visit our hompage to get where you need to go.
                      {/* <Link to="/support" className="text-red-700 ml-1 hover:underline">Raise issue?</Link> */}
                    </p>
                    <Flex gap={2} alignItems="center">
                      <Button onClick={navigateToHome}>Take me there!</Button>
                      <div onClick={reload}>
                        <Icon icon={faRefresh} name="refresh-regular" onClick={reload} className="cursor-pointer" />
                      </div>
                    </Flex>
                  </div>
                </div>
                <div className="w-full h-full bottom-20">
                  <p className="md:text-[12rem] text-[8rem] font-extrabold text-gray-100">{errorData?.status}</p>
                </div>
              </div>
            </div>
            <div className="w-full h-full px-2">
              <img loading="lazy" alt="background" src={disconnect} />
            </div>
          </div>
        </Flex>
      </Body>
    </Page>
  );
};

export default ErrorComponent;
